"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _debounce = _interopRequireDefault(require("./debounce"));
var _useResizeObserver = _interopRequireDefault(require("./useResizeObserver"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useAutoOverflow = function useAutoOverflow() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    targetRef = _ref.targetRef,
    children = _ref.children,
    _ref$overflowPadding = _ref.overflowPadding,
    overflowPadding = _ref$overflowPadding === void 0 ? 0 : _ref$overflowPadding,
    overflowFromStart = _ref.overflowFromStart;
  var childrenCount = _react.default.Children.count(children);
  var _useState = (0, _react.useState)(overflowFromStart ? 0 : childrenCount),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    overflowIndex = _useState2[0],
    setOverflowIndex = _useState2[1];
  var childRefs = (0, _react.useRef)([]);
  var isItemAllowedToOverflow = function isItemAllowedToOverflow(index) {
    var _childRefs$current$in;
    return !((_childRefs$current$in = childRefs.current[index]) !== null && _childRefs$current$in !== void 0 && _childRefs$current$in.getAttribute('data-no-overflow'));
  };
  var markOverflowItems = function markOverflowItems(containerWidth) {
    // if the last item is fully visible, no more work is required
    var lastItem = childRefs.current[childrenCount - 1];
    var lastItemOffsetRight = (lastItem === null || lastItem === void 0 ? void 0 : lastItem.offsetLeft) + (lastItem === null || lastItem === void 0 ? void 0 : lastItem.offsetWidth);
    if (lastItemOffsetRight < containerWidth) return;
    var idx;
    if (overflowFromStart) {
      var amountToRemove = lastItemOffsetRight - containerWidth;
      var amountRemoved = 0;
      for (idx = 0; idx < ((_childRefs$current = childRefs.current) === null || _childRefs$current === void 0 ? void 0 : _childRefs$current.length); idx += 1) {
        var _childRefs$current, _childRefs$current2;
        var item = childRefs.current[idx];
        var nextItem = idx !== ((_childRefs$current2 = childRefs.current) === null || _childRefs$current2 === void 0 ? void 0 : _childRefs$current2.length) - 1 ? childRefs.current[idx + 1] : null;
        if (isItemAllowedToOverflow(idx)) {
          var itemWidth = nextItem ? (nextItem === null || nextItem === void 0 ? void 0 : nextItem.offsetLeft) - (item === null || item === void 0 ? void 0 : item.offsetLeft) : item === null || item === void 0 ? void 0 : item.offsetWidth;
          amountRemoved += itemWidth;
          if (amountRemoved > amountToRemove) {
            idx += 1;
            break;
          }
        }
      }
    } else {
      // from end
      var _amountToRemove = lastItemOffsetRight - containerWidth;
      var _amountRemoved = 0;
      for (idx = ((_childRefs$current3 = childRefs.current) === null || _childRefs$current3 === void 0 ? void 0 : _childRefs$current3.length) - 1; idx >= 0; idx -= 1) {
        var _childRefs$current3;
        var _item = childRefs.current[idx];
        var prevItem = idx !== 0 ? childRefs.current[idx - 1] : null;
        if (isItemAllowedToOverflow(idx)) {
          var _itemWidth = prevItem ? (_item === null || _item === void 0 ? void 0 : _item.offsetLeft) - (prevItem === null || prevItem === void 0 ? void 0 : prevItem.offsetLeft) : _item === null || _item === void 0 ? void 0 : _item.offsetWidth;
          _amountRemoved += _itemWidth;
          if (_amountRemoved > _amountToRemove) {
            break;
          }
        }
      }
    }
    setOverflowIndex(idx);
  };
  var handleResize = (0, _debounce.default)(function (_ref2) {
    var width = _ref2.width;
    // have to get all items re-rendered in order to do new calculations
    setOverflowIndex(overflowFromStart ? 0 : childrenCount);
    markOverflowItems(width - overflowPadding);
  });
  (0, _useResizeObserver.default)({
    targetRef: targetRef,
    onResize: handleResize
  });
  var isItemOverflown = function isItemOverflown(index) {
    return overflowFromStart ? index < overflowIndex : index >= overflowIndex;
  };
  var getChildrenToRender = function getChildrenToRender() {
    var _context;
    return (0, _map.default)(_context = _react.default.Children).call(_context, children, function (child, index) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        style: isItemAllowedToOverflow(index) && isItemOverflown(index) ? {
          display: 'none'
        } : undefined,
        'data-is-overflown': isItemAllowedToOverflow(index) && isItemOverflown(index) ? true : undefined,
        ref: (0, _reactMergeRefs.default)([child === null || child === void 0 ? void 0 : child.ref, function (element) {
          childRefs.current[index] = element;
        }])
      });
    });
  };
  var overflowChildrenToRender = [];
  _react.default.Children.forEach(children, function (child, index) {
    if (isItemAllowedToOverflow(index) && isItemOverflown(index)) {
      overflowChildrenToRender.push(child);
    }
  });
  return {
    overflowIndex: overflowIndex,
    handleResize: handleResize,
    isOverflowing: overflowChildrenToRender.length > 0,
    childrenToRender: getChildrenToRender(),
    overflowChildrenToRender: overflowChildrenToRender
  };
};
var _default = useAutoOverflow;
exports.default = _default;